import { createContext, useContext, useMemo, useRef } from 'react';

const KeyboardModeContext = createContext(null);

export function useKeyboardMode() {
  return useContext(KeyboardModeContext);
}

export default function KeyboardModeProvider({ children }) {
  const lastStandardPathRef = useRef('/');

  const value = useMemo(
    () => ({
      getLastStandardPath: () => lastStandardPathRef.current,
      setLastStandardPath: (path) => {
        lastStandardPathRef.current = path;
      },
    }),
    []
  );

  return <KeyboardModeContext.Provider value={value}>{children}</KeyboardModeContext.Provider>;
}
